import React from "react";
import {Typography} from "antd";

import {i18, trb, CustomIcon} from "../../../Utilities";

export const LoginBubble = React.memo(() => {
    return (
        <div>
            <img src="/images/slider/onboarding_login.svg" className="w-100" alt="start onboarding icon"/>
        </div>
    );
});
